module.exports = __webpack_public_path__ + "static/media/profile_19.20e3da45.jpg";